import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Cabinet_Interface } from 'src/app/Interface/Cabinet_Interface';
import { DeviceBehfa_Gostareh_Interface, Empty_DeviceBehfa_Gostareh_Interface } from 'src/app/Interface/DeviceBehfa_Gostareh_Interface';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { DeviceGroup_Interface } from 'src/app/Interface/DeviceGroup_Interface';
import { ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CabinetService } from 'src/app/Service/Cabinet/Cabinet.service';
import { ContractorService } from 'src/app/Service/Contractor/Contractor.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { DeviceGroupService } from 'src/app/Service/DeviceGroup/DeviceGroup.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { MoneyService } from 'src/app/Service/Money/Money.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-DeviceBehfaAdd',
  templateUrl: './DeviceBehfaAdd.component.html',
  styleUrls: ['./DeviceBehfaAdd.component.scss']
})
export class DeviceBehfaAddComponent implements OnInit {

  Token: String = ""
  AddNewDeviceBehfa: FormGroup;
  InProccessing: boolean = false

  @Output() OnBack_DeviceBehfa_Action = new EventEmitter<number>();

  constructor(
    private DeviceBehfa_Service: DeviceBehfaService,
    private Nav_Service: NavService,
    private Expert_CalibrationService: ExpertCalibrationService,
    private DeviceGroup_Service: DeviceGroupService,
    private Money_Service: MoneyService,
    private Unit_Service: UnitService,
    private Cabinet_Service: CabinetService,
    private Contractor_Service: ContractorService,
    private Alertify_Service: AlertifyService,
    private ExpertCalibration_Service: ExpertCalibrationService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.MonthList = Array(36).fill(1).map((x, i) => i + 1);
    this.DayList = Array(31).fill(1).map((x, i) => i + 1);

    this.AddNewDeviceBehfa = new FormGroup({
      id: new FormControl(),
      GroupId: new FormControl("0", Validators.required),
      SubGroupId: new FormControl("0", Validators.required),
      NeedCalibration: new FormControl("1", Validators.required),
      Description: new FormControl(null, Validators.required),
      Manufacturer: new FormControl(null, Validators.required),
      Model: new FormControl(null, Validators.required),
      CodeBEHFA: new FormControl(null, Validators.required),
      Serial: new FormControl(null, Validators.required),
      Countery: new FormControl(null, Validators.required),
      SellerContractor: new FormControl("0", Validators.required),
      Seller: new FormControl("0", Validators.required),
      Price: new FormControl(null, Validators.required),
      PriceVahed: new FormControl("0", Validators.required),
      dateBuy: new FormControl(null, Validators.required),
      dateRun: new FormControl(null, Validators.required),
      count: new FormControl(1, Validators.required),
      FixerContractor: new FormControl("0"),
      type: new FormControl(),
      Fixer: new FormControl("0"),
      Cabinet_id: new FormControl("0"),
      CategoryId: new FormControl("0"),

      InitialStatus: new FormControl("-1"),
      CalibrationPeriod: new FormControl(null, Validators.required),
      WarningTime: new FormControl("0", Validators.required),

      TechnicalSpecifications: new FormControl(null, Validators.required),
      TechnicalDsc: new FormControl(null, Validators.required),
      EnvironmentalConditions: new FormControl(null, Validators.required),
      JobAlerts: new FormControl(null, Validators.required),
      ConditionKeep: new FormControl(null, Validators.required),
      ConditionTransport: new FormControl(null, Validators.required),


      CertificateNo: new FormControl(null),
      CalibratingCompany: new FormControl("0"),
      CalibratingCustomer: new FormControl("0"),
      CalibratingName: new FormControl("0"),
      CalibratingNameType: new FormControl(),
      Uncertainty: new FormControl(null),

      CalibratingPrice: new FormControl(null),
      CalibratingPriceVahed: new FormControl("0"),

      CalDueType: new FormControl("0"),
      CalDueMiladi: new FormControl(null),
      CalDueShamsi: new FormControl(null),

      CalDATEType: new FormControl("0"),
      CalDATEMiladi: new FormControl(null),
      CalDATEShamsi: new FormControl(null),

      GostarehVahed: new FormControl("0"),
      GostarehMin: new FormControl(null),
      GostarehMax: new FormControl(null),
      Zineh: new FormControl(null),

      HadMojazVahed: new FormControl("0"),
      HadMojaz: new FormControl(null),

      AfradMojaz: new FormControl("0"),
    })

    this.Nav_Service.CheckValidPage(this.Token, 46).subscribe(
      data => {
        this.ReadData_DeviceGroup()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  NeedCalibration_Change() {
    if (this.get_Form_NeedCalibration().value == '1') {
      this.get_Form_CalibrationPeriod().setValue("0")
    }
    else {
      this.get_Form_CalibrationPeriod().setValue("1")
    }
  }

  //#region  Form Add

  AddNewSkill: FormGroup;

  get_Form_GroupId() {
    return this.AddNewDeviceBehfa.get('GroupId') as FormControl;
  }
  get_Form_count() {
    return this.AddNewDeviceBehfa.get('count') as FormControl;
  }
  get_Form_SubGroupId() {
    return this.AddNewDeviceBehfa.get('SubGroupId') as FormControl;
  }
  get_Form_NeedCalibration() {
    return this.AddNewDeviceBehfa.get('NeedCalibration') as FormControl;
  }
  get_Form_Description() {
    return this.AddNewDeviceBehfa.get('Description') as FormControl;
  }
  get_Form_Manufacturer() {
    return this.AddNewDeviceBehfa.get('Manufacturer') as FormControl;
  }
  get_Form_Model() {
    return this.AddNewDeviceBehfa.get('Model') as FormControl;
  }
  get_Form_Serial() {
    return this.AddNewDeviceBehfa.get('Serial') as FormControl;
  }

  get_Form_Countery() {
    return this.AddNewDeviceBehfa.get('Countery') as FormControl;
  }

  get_Form_Seller() {
    return this.AddNewDeviceBehfa.get('Seller') as FormControl;
  }

  get_Form_SellerContractor() {
    return this.AddNewDeviceBehfa.get('SellerContractor') as FormControl;
  }

  get_Form_type() {
    return this.AddNewDeviceBehfa.get('type') as FormControl;
  }

  get_Form_Price() {
    return this.AddNewDeviceBehfa.get('Price') as FormControl;
  }

  get_Form_PriceVahed() {
    return this.AddNewDeviceBehfa.get('PriceVahed') as FormControl;
  }

  get_Form_Fixer() {
    return this.AddNewDeviceBehfa.get('Fixer') as FormControl;
  }

  get_Form_FixerContractor() {
    return this.AddNewDeviceBehfa.get('FixerContractor') as FormControl;
  }


  get_Form_InitialStatus() {
    return this.AddNewDeviceBehfa.get('InitialStatus') as FormControl;
  }

  get_Form_CalibrationPeriod() {
    return this.AddNewDeviceBehfa.get('CalibrationPeriod') as FormControl;
  }

  get_Form_Cabinet_id() {
    return this.AddNewDeviceBehfa.get('Cabinet_id') as FormControl;
  }

  get_Form_CategoryId() {
    return this.AddNewDeviceBehfa.get('CategoryId') as FormControl;
  }

  get_Form_WarningTime() {
    return this.AddNewDeviceBehfa.get('WarningTime') as FormControl;
  }
  get_Form_TechnicalSpecifications() {
    return this.AddNewDeviceBehfa.get('TechnicalSpecifications') as FormControl;
  }
  get_Form_TechnicalDsc() {
    return this.AddNewDeviceBehfa.get('TechnicalDsc') as FormControl;
  }
  get_Form_JobAlerts() {
    return this.AddNewDeviceBehfa.get('JobAlerts') as FormControl;
  }
  get_Form_ConditionKeep() {
    return this.AddNewDeviceBehfa.get('ConditionKeep') as FormControl;
  }
  get_Form_ConditionTransport() {
    return this.AddNewDeviceBehfa.get('ConditionTransport') as FormControl;
  }
  get_Form_EnvironmentalConditions() {
    return this.AddNewDeviceBehfa.get('EnvironmentalConditions') as FormControl;
  }

  get_Form_CodeBEHFA() {
    return this.AddNewDeviceBehfa.get('CodeBEHFA') as FormControl;
  }

  get_Form_CertificateNo() {
    return this.AddNewDeviceBehfa.get('CertificateNo') as FormControl;
  }


  get_Form_CalDueMiladi() {
    return this.AddNewDeviceBehfa.get('CalDueMiladi') as FormControl;
  }
  get_Form_CalDueShamsi() {
    return this.AddNewDeviceBehfa.get('CalDueShamsi') as FormControl;
  }
  get_Form_CalDueType() {
    return this.AddNewDeviceBehfa.get('CalDueType') as FormControl;
  }
  get_Form_CalDATEMiladi() {
    return this.AddNewDeviceBehfa.get('CalDATEMiladi') as FormControl;
  }
  get_Form_CalDATEShamsi() {
    return this.AddNewDeviceBehfa.get('CalDATEShamsi') as FormControl;
  }
  get_Form_CalDATEType() {
    return this.AddNewDeviceBehfa.get('CalDATEType') as FormControl;
  }
  get_Form_CalibratingCompany() {
    return this.AddNewDeviceBehfa.get('CalibratingCompany') as FormControl;
  }
  get_Form_CalibratingCustomer() {
    return this.AddNewDeviceBehfa.get('CalibratingCustomer') as FormControl;
  }
  get_Form_CalibratingNameType() {
    return this.AddNewDeviceBehfa.get('CalibratingNameType') as FormControl;
  }
  get_Form_CalibratingName() {
    return this.AddNewDeviceBehfa.get('CalibratingName') as FormControl;
  }
  get_Form_dateBuy() {
    return this.AddNewDeviceBehfa.get('dateBuy') as FormControl;
  }
  get_Form_dateRun() {
    return this.AddNewDeviceBehfa.get('dateRun') as FormControl;
  }
  get_Form_Uncertainty() {
    return this.AddNewDeviceBehfa.get('Uncertainty') as FormControl;
  }

  get_Form_CalibratingPrice() {
    return this.AddNewDeviceBehfa.get('CalibratingPrice') as FormControl;
  }

  get_Form_CalibratingPriceVahed() {
    return this.AddNewDeviceBehfa.get('CalibratingPriceVahed') as FormControl;
  }

  get_Form_GostarehVahed() {
    return this.AddNewDeviceBehfa.get('GostarehVahed') as FormControl;
  }

  get_Form_GostarehMin() {
    return this.AddNewDeviceBehfa.get('GostarehMin') as FormControl;
  }

  get_Form_GostarehMax() {
    return this.AddNewDeviceBehfa.get('GostarehMax') as FormControl;
  }
  get_Form_Zineh() {
    return this.AddNewDeviceBehfa.get('Zineh') as FormControl;
  }

  get_Form_HadMojazVahed() {
    return this.AddNewDeviceBehfa.get('HadMojazVahed') as FormControl;
  }

  get_Form_HadMojaz() {
    return this.AddNewDeviceBehfa.get('HadMojaz') as FormControl;
  }

  get_Form_AfradMojaz() {
    return this.AddNewDeviceBehfa.get('AfradMojaz') as FormControl;
  }


  MonthList = []
  DayList = []

  //#endregion



  //#region Group

  DataList_DeviceGroup_Parent: Array<DeviceGroup_Interface> = []
  DataList_DeviceGroup_Child: Array<DeviceGroup_Interface> = []
  DataList_DeviceGroup_Child2: Array<DeviceGroup_Interface> = []
  ReadData_DeviceGroup() {

    this.DeviceGroup_Service.GetTree(this.Token).subscribe(
      data => {

        this.DataList_DeviceGroup_Parent = data['parent']
        this.DataList_DeviceGroup_Child = data['child']

        this.Read_ExpertCalibration()

      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  GroupChange() {
    var id = Number(this.get_Form_GroupId().value)
    this.DataList_DeviceGroup_Child2 = []
    for (let itemdetail of this.DataList_DeviceGroup_Child) {
      if (itemdetail.parent == id) {
        this.DataList_DeviceGroup_Child2.push(itemdetail)
      }
    }
  }

  //#endregion



  SubmitAddNewDevice() {

    if (!this.AddNewDeviceBehfa.valid) {
      this.AddNewDeviceBehfa.markAllAsTouched()
    }
    else if (this.get_Form_SubGroupId().value == "0") {
      this.Alertify_Service.ErrorMessage("Select the subgroup.")
    }
    else if (this.get_Form_InitialStatus().value == "-1") {
      this.Alertify_Service.ErrorMessage("Select the initial condition.")
    }
    else if (this.get_Form_CalibrationPeriod().value > 60 || this.get_Form_CalibrationPeriod().value < 0) {
      this.Alertify_Service.ErrorMessage("Enter the calibration interval in months.")
    }
    else if (this.get_Form_WarningTime().value == "0" && this.get_Form_NeedCalibration().value == "1") {
      this.Alertify_Service.ErrorMessage("Select the calibration expiration warning period in days.")
    }
    else {

      var tempFixer: Array<Number> = []
      for (let item of this.RabetMasolCustomer_Fixer) {
        tempFixer.push(item.id)
      }

      var tempAfradMojaz: Array<Number> = []
      for (let item of this.DataList_AfradMojaz) {
        tempAfradMojaz.push(item.id)
      }



      this.InProccessing = true
      var temp: DeviceBehfa_Interface = Empty_DeviceBehfa_Interface();
      temp.id = 0
      temp.group_id = Number(this.get_Form_SubGroupId().value)
      temp.count = Number(this.get_Form_count().value)

      temp.needCalibration = (this.get_Form_NeedCalibration().value == '1')
      temp.description = this.get_Form_Description().value
      temp.manufacturer = this.get_Form_Manufacturer().value
      temp.model = this.get_Form_Model().value
      temp.codeBEHFA = this.get_Form_CodeBEHFA().value
      temp.serial = this.get_Form_Serial().value
      temp.countery = this.get_Form_Countery().value
      temp.seller = Number(this.get_Form_Seller().value)
      temp.SellerContractor = Number(this.get_Form_SellerContractor().value)
      temp.price = Number(this.get_Form_Price().value)
      temp.priceVahed = Number(this.get_Form_PriceVahed().value)
      temp.dateBuy = this.get_Form_dateBuy().value
      temp.dateRun = this.get_Form_dateRun().value
      temp.type = this.get_Form_type().value
      //temp.fixer=tempFixer

      temp.cabinet_id = Number(this.get_Form_Cabinet_id().value)
      temp.category_id = Number(this.get_Form_CategoryId().value)

      temp.initialStatus = (this.get_Form_InitialStatus().value == '1')
      temp.calibrationPeriod = Number(this.get_Form_CalibrationPeriod().value)
      temp.warningTime = Number(this.get_Form_WarningTime().value)

      temp.technicalSpecifications = this.get_Form_TechnicalSpecifications().value
      temp.technicalDsc = this.get_Form_TechnicalDsc().value
      temp.environmentalConditions = this.get_Form_EnvironmentalConditions().value
      temp.jobAlerts = this.get_Form_JobAlerts().value
      temp.conditionKeep = this.get_Form_ConditionKeep().value
      temp.conditionTransport = this.get_Form_ConditionTransport().value

      temp.calibratingprice = Number(this.get_Form_CalibratingPrice().value)
      temp.calibratingpriceVahed = Number(this.get_Form_CalibratingPriceVahed().value)

      temp.certificateNo = this.get_Form_CertificateNo().value + ""
      temp.calibratingCompany = this.get_Form_CalibratingCompany().value
      temp.calibratingCustomer = this.get_Form_CalibratingCustomer().value
      temp.calibratingName = this.get_Form_CalibratingName().value
      temp.calibratingNameType = this.get_Form_CalibratingNameType().value
      temp.uncertainty = this.get_Form_Uncertainty().value

      temp.calDueType = Number(this.get_Form_CalDueType().value)
      temp.calDueMiladi = this.get_Form_CalDueMiladi().value
      temp.calDueShamsi = this.get_Form_CalDueShamsi().value

      temp.calDATEType = Number(this.get_Form_CalDATEType().value)
      temp.calDATEMiladi = this.get_Form_CalDATEMiladi().value
      temp.calDATEShamsi = this.get_Form_CalDATEShamsi().value


      this.DeviceBehfa_Service.AddDevice(temp,
        this.UploadImageSrc_List,
        this.DataList_Gostareh,
        tempFixer,
        tempAfradMojaz,
        this.Token).subscribe(
          data => {
            this.InProccessing = false
            if (data.id == -2) {
              this.Alertify_Service.ErrorMessage("The entered certificate number already exists in the list.")
            }
            else {
              this.AddNewDeviceBehfa.reset()
              this.UploadImageSrc_List = []
              this.RabetMasolCustomer_Fixer = []
              this.get_Form_SubGroupId().setValue("0")
              this.get_Form_GroupId().setValue("0")
              this.get_Form_InitialStatus().setValue("-1")
              this.get_Form_CalibrationPeriod().setValue("0")
              this.get_Form_WarningTime().setValue("0")
              this.get_Form_NeedCalibration().setValue("0")
              this.get_Form_CalDATEType().setValue("0")
              this.get_Form_count().setValue("0")
              this.get_Form_PriceVahed().setValue("0")
              this.get_Form_GostarehVahed().setValue("0")
              this.get_Form_HadMojazVahed().setValue("0")
              this.get_Form_CalibratingPriceVahed().setValue("0")
              this.get_Form_CalDueType().setValue("0")
              this.get_Form_Seller().setValue("0")
              this.get_Form_Fixer().setValue("0")
              this.get_Form_CalibratingCompany().setValue("0")
              this.get_Form_CalibratingCustomer().setValue("0")
              this.DataList_Gostareh = []
              this.Alertify_Service.SuccessMessage("Information saved successfully.")
            }
          }, error => {
            localStorage.clear()
            location.reload();

          }
        )
    }
  }



  //#region ExpertCalibration

  DataList_ExpertCalibration: Array<ExpertCalibration_Interface> = []
  Read_ExpertCalibration() {
    this.Expert_CalibrationService.GetActiveList(this.Token, true, true, true).subscribe(
      data => {
        this.Read_Money()
        this.DataList_ExpertCalibration = data
      }
    )
  }

  //#endregion

  //#region Authorized repairer

  RabetMasolCustomer_Fixer: Array<General_Interface> = []
  OnAdd_RabetMasolCustomer_Fixer() {

    var Exited: boolean = false
    for (let item of this.RabetMasolCustomer_Fixer) {
      if (item.id == Number(this.get_Form_Fixer().value)) {
        Exited = true;
        break
      }
    }

    if (Exited) {
      this.Alertify_Service.ErrorMessage("The authorized repairer already exists in the list.")
    }
    else {
      var temp: General_Interface = Empty_General_Interface()
      temp.id = Number(this.get_Form_Fixer().value)
      temp.title = this.Get_Title_Contractor_Customer(Number(this.get_Form_Fixer().value))
      this.RabetMasolCustomer_Fixer.push(temp)


      this.Alertify_Service.SuccessMessage("The authorized repairer was added to the list.")
    }
  }
  RabetMasolCustomer_Fixer_Delete(id) {
    this.RabetMasolCustomer_Fixer.splice(id, 1)
    this.Alertify_Service.SuccessMessage("The repairer was removed from the list.")
  }

  //#endregion

  //#region Image
  BaseUrl = environment.BaseUrl
  UploadImageSrc_List: Array<string> = []
  UploadImageSrc: string = ''
  InProccessing_Image1: boolean = false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1 = true

    this.DeviceBehfa_Service.uploadFile(formData, this.Token).subscribe(
      data => {
        this.InProccessing_Image1 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.UploadImageSrc = data['filename']
        }
      }
    )

  }

  Remove_uploadImage1() {
    this.UploadImageSrc = ''
  }

  Add_uploadImage1() {
    this.UploadImageSrc_List.push(this.UploadImageSrc)
    this.UploadImageSrc = ''
    this.Alertify_Service.SuccessMessage("Added to the table.")
  }

  UploadImageSrc_List_Delete(id: number) {
    this.UploadImageSrc_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("Deleted successfully.")
  }

  //#endregion

  //#region Money

  DataList_Money: Array<General_Interface> = []
  Read_Money() {
    this.Money_Service.GetActiveList(this.Token).subscribe(
      data => {
        this.DataList_Money = data
        this.ReadData_Unit()
      }
    )
  }

  //#endregion

  //#region Unit

  DataList_Unit: Array<Unit_Interface> = []
  ReadData_Unit() {
    this.Unit_Service.GetRecord(this.Token).subscribe(
      data => {
        this.DataList_Unit = data
        this.ReadData_Contractor()
      }
    )
  }

  Get_Title_Unit(id): string {
    for (let item of this.DataList_Unit) {
      if (item.id == id) {
        return item.title + ''
      }
    }
    return ""
  }

  //#endregion

  //#region Gostareh

  DataList_Gostareh: Array<DeviceBehfa_Gostareh_Interface> = []
  OnAdd_Gostareh() {

    if (this.DataList_Gostareh.length >= 100) {
      this.Alertify_Service.ErrorMessage(" No more than 100 entries can be registered.")
    }
    else if (!this.get_Form_GostarehMin().value && this.get_Form_GostarehMin().value != "0") {
      this.Alertify_Service.ErrorMessage("Enter the minimum value.")
    }
    else if (!this.get_Form_GostarehMax().value && this.get_Form_GostarehMax().value != "0") {
      this.Alertify_Service.ErrorMessage("Enter the maximum value.")
    }
    else if (!this.get_Form_Zineh().value && this.get_Form_Zineh().value != "0") {
      this.Alertify_Service.ErrorMessage("Enter the increment.")
    }
    else if (Number(this.get_Form_GostarehMin().value) > Number(this.get_Form_GostarehMax().value)) {
      this.Alertify_Service.ErrorMessage("Check the minimum and maximum values.")
    }
    else if (this.get_Form_GostarehVahed().value == "0") {
      this.Alertify_Service.ErrorMessage("Select the unit.")
    }
    else if (!this.get_Form_HadMojaz().value) {
      this.Alertify_Service.ErrorMessage("Enter the maximum permissible error.")
    }
    else if (this.get_Form_HadMojazVahed().value == "0") {
      this.Alertify_Service.ErrorMessage("Select the maximum permissible error unit.")
    }
    else if (this.Edit_DataList_Gostareh_Indxer > -1) {
      this.DataList_Gostareh[this.Edit_DataList_Gostareh_Indxer].min = Number(this.get_Form_GostarehMin().value)
      this.DataList_Gostareh[this.Edit_DataList_Gostareh_Indxer].max = Number(this.get_Form_GostarehMax().value)
      this.DataList_Gostareh[this.Edit_DataList_Gostareh_Indxer].zineh = Number(this.get_Form_Zineh().value)

      this.DataList_Gostareh[this.Edit_DataList_Gostareh_Indxer].vahed_id = Number(this.get_Form_GostarehVahed().value)
      this.DataList_Gostareh[this.Edit_DataList_Gostareh_Indxer].vahed_title = this.Get_Title_Unit(Number(this.get_Form_GostarehVahed().value))

      this.DataList_Gostareh[this.Edit_DataList_Gostareh_Indxer].error = this.get_Form_HadMojaz().value
      this.DataList_Gostareh[this.Edit_DataList_Gostareh_Indxer].error_vahed_id = Number(this.get_Form_HadMojazVahed().value)
      this.DataList_Gostareh[this.Edit_DataList_Gostareh_Indxer].error_vahed_title = this.Get_Title_Unit(Number(this.get_Form_HadMojazVahed().value))

      this.Edit_DataList_Gostareh_Indxer = -1
    }
    else {
      var temp: DeviceBehfa_Gostareh_Interface = Empty_DeviceBehfa_Gostareh_Interface()
      temp.id = 0

      temp.min = Number(this.get_Form_GostarehMin().value)
      temp.max = Number(this.get_Form_GostarehMax().value)
      temp.zineh = Number(this.get_Form_Zineh().value)

      temp.vahed_id = Number(this.get_Form_GostarehVahed().value)
      temp.vahed_title = this.Get_Title_Unit(Number(this.get_Form_GostarehVahed().value))

      temp.error = this.get_Form_HadMojaz().value
      temp.error_vahed_id = Number(this.get_Form_HadMojazVahed().value)
      temp.error_vahed_title = this.Get_Title_Unit(Number(this.get_Form_HadMojazVahed().value))

      this.DataList_Gostareh.push(temp)
    }

  }

  Edit_DataList_Gostareh_Indxer: number = -1;
  Edit_DataList_Gostareh(id: number) {
    this.Edit_DataList_Gostareh_Indxer = id
    this.DataList_Gostareh[id]

    var temp = this.DataList_Gostareh[id]
    this.get_Form_GostarehMin().setValue(temp.min)
    this.get_Form_GostarehMax().setValue(temp.max)
    this.get_Form_Zineh().setValue(temp.zineh)

    this.get_Form_GostarehVahed().setValue(temp.vahed_id)
    this.get_Form_HadMojaz().setValue(temp.error)
    this.get_Form_HadMojazVahed().setValue(temp.error_vahed_id)

  }

  Delete_DataList_Gostareh(id) {
    this.DataList_Gostareh.splice(id, 1)
    this.Alertify_Service.SuccessMessage("Deleted successfully.")
  }

  //#endregion

  //#region Contractor


  Get_Title_Contractor(id): string {
    for (let item of this.DataList_Contractor) {
      if (item.id == id) {
        return item.title + ''
      }
    }
    return ""
  }

  Get_Title_Contractor_Customer(id): string {
    console.log(id);
    console.log(this.DataList_Contractor_Fixer);

    for (let item of this.DataList_Contractor_Fixer) {
      if (item.id == id) {
        return item.title + ' - ' + this.Get_Title_Contractor(Number(item.code))
      }
    }
    return ""
  }

  DataList_Contractor: Array<General_Interface> = []
  ReadData_Contractor() {
    this.Contractor_Service.GetActiveList(this.Token).subscribe(
      data => {
        this.ReadData_Cabinet()
        this.DataList_Contractor = data
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  DataList_Contractor_Seller: Array<General_Interface> = []
  ReadData_Contractor_Seller() {
    this.get_Form_Seller().setValue("0")
    this.Contractor_Service.GetCustomerActiveList(this.Token, Number(this.get_Form_SellerContractor().value)).subscribe(
      data => {
        this.DataList_Contractor_Seller = data
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  DataList_Contractor_Fixer: Array<General_Interface> = []
  ReadData_Contractor_Fixer() {
    this.get_Form_Fixer().setValue("0")
    this.Contractor_Service.GetCustomerActiveList(this.Token, Number(this.get_Form_FixerContractor().value)).subscribe(
      data => {
        this.DataList_Contractor_Fixer = data
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  DataList_Contractor_CalibratingCustomer: Array<General_Interface> = []
  ReadData_Contracto_CalibratingCustomer() {
    this.get_Form_CalibratingCustomer().setValue("0")
    this.Contractor_Service.GetCustomerActiveList(this.Token, Number(this.get_Form_CalibratingCompany().value)).subscribe(
      data => {
        this.DataList_Contractor_CalibratingCustomer = data
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#endregion

  //#region Cabinet

  DataList_Cabinet: Array<Cabinet_Interface> = []
  ReadData_Cabinet() {
    this.Cabinet_Service.GetActiveList(this.Token).subscribe(
      data => {
        this.DataList_Cabinet = data
      }
    )
  }

  //#endregion

  //#region Afrad Mojaz

  DataList_AfradMojaz: Array<General_Interface> = []
  OnAdd_AfradMojaz() {

    if (this.get_Form_AfradMojaz().value == "0") {
      this.Alertify_Service.ErrorMessage("Select a technician.")
    }
    else if (this.Check_Exist_AfradMojaz(Number(this.get_Form_AfradMojaz().value))) {
      this.Alertify_Service.ErrorMessage("The technician has already been selected.")
    }
    else {
      var temp: General_Interface = Empty_General_Interface()


      temp.id = Number(this.get_Form_AfradMojaz().value)
      temp.title = this.Get_AfradMojaz_Title(Number(this.get_Form_AfradMojaz().value)) + ''

      this.DataList_AfradMojaz.push(temp)
    }
  }

  Check_Exist_AfradMojaz(id: number) {
    for (let item of this.DataList_AfradMojaz) {
      if (item.id == id)
        return true
    }
    return false
  }

  Get_AfradMojaz_Title(id: number) {
    for (let item of this.DataList_ExpertCalibration) {
      if (item.id == id)
        return item.name + ' ' + item.familly
    }
    return false
  }

  Delete_DataList_AfradMojaz(id) {
    this.DataList_AfradMojaz.splice(id, 1)
    this.Alertify_Service.SuccessMessage("Deleted successfully.")
  }

  //#endregion


  OnBack_DeviceBehfaList() {
    this.OnBack_DeviceBehfa_Action.emit(-1);
  }

}
